import React from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { ArrowRight, MapPin, Phone } from 'lucide-react';
import { site } from '../data/site';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/85c3e07b-92b3-4ca2-9605-ab6e9d21cdde.jpg';
export function Hero() {
  const {
    scrollY
  } = useScroll();
  const reduceMotion = useReducedMotion();
  const y = useTransform(scrollY, [0, 700], [0, reduceMotion ? 0 : 120]);
  const scale = useTransform(scrollY, [0, 700], [1, reduceMotion ? 1 : 1.08]);
  return <section id="top" className="relative isolate min-h-[92vh] w-full overflow-hidden bg-navy-900" data-id="element-188" data-mp="x8jm7l6zcogo">
      <motion.div style={{
      y,
      scale
    }} className="absolute inset-0 -z-10" data-id="element-189" data-mp="sd4aozwg34nf">
        <motion.img src={HERO_IMAGE} alt="Beautifully remodeled Kentucky kitchen and living space at golden hour" className="h-full w-full object-cover" initial={{
        opacity: 0,
        scale: 1.12
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-190" data-mp="nbygsyr1tbcb" />
        <div className="absolute inset-0 bg-navy-900/70" data-id="element-191" data-mp="3o85a17s6zv2z" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/40 to-navy-900/70" data-id="element-192" data-mp="3o5j39ad4ljlt" />
      </motion.div>

      <div className="mx-auto flex min-h-[92vh] max-w-[1400px] flex-col justify-end px-5 pb-20 pt-32 sm:px-8 md:justify-center md:pb-28 md:pt-36" data-id="element-193" data-mp="3e9607lvoxtee">
        <div className="max-w-3xl" data-id="element-194" data-mp="30h9ebzkm8fqg">
          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.35,
          duration: 0.7
        }} className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-brass-light" data-id="element-195" data-mp="30g6kpjvwrz6u">
            <span className="h-px w-10 bg-brass/70" aria-hidden="true" data-id="element-196" data-mp="2vgllr9gqnqu4" />
            Kentucky Remodeling &amp; Painting
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5,
          duration: 0.9,
          ease: [0.22, 1, 0.36, 1]
        }} className="mt-6 font-display text-[clamp(2.6rem,7.5vw,5.6rem)] font-normal leading-[0.98] tracking-[-0.02em] text-white" data-id="element-197" data-mp="2ll0g91cgo8fm">
            Make Your Home
            <span className="block italic text-brass-light" data-id="element-198" data-mp="i9vp4yrrfqj7">Unbelievable.</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.68,
          duration: 0.8
        }} className="mt-7 max-w-xl text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-199" data-mp="1b0vx1kt7peg5">
            Professional remodeling and painting services built around quality
            craftsmanship, attention to detail, and results you&rsquo;ll be proud to
            come home to.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.82,
          duration: 0.8
        }} className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-200" data-mp="3lu9xn2arm0br">
            <a href="#contact" className="group inline-flex items-center justify-center gap-3 rounded-full bg-brass px-8 py-4 text-xs font-bold uppercase tracking-[0.18em] text-navy-900 transition-all duration-300 hover:bg-brass-light hover:shadow-[0_18px_40px_-18px_rgba(192,149,79,1)]" data-id="element-201" data-mp="21a4t5ua36g5g">
              Get a Free Estimate
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-202" data-mp="2kyvntiovxwlb" />
            </a>
            <a href={site.phoneHref} className="inline-flex items-center justify-center gap-3 rounded-full border border-white/30 px-8 py-4 text-xs font-bold uppercase tracking-[0.18em] text-white backdrop-blur-sm transition-all duration-300 hover:border-white/60 hover:bg-white/10" data-id="element-203" data-mp="2oyebunc06nsd">
              <Phone className="h-4 w-4" aria-hidden="true" data-id="element-204" data-mp="4b477td2c4jg" />
              Call Now
            </a>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1,
          duration: 0.9
        }} className="mt-8 flex items-center gap-2 text-[13px] tracking-wide text-white/60" data-id="element-205" data-mp="3vgngkprljrps">
            <MapPin className="h-4 w-4 text-brass" aria-hidden="true" data-id="element-206" data-mp="98mjntqah1w7" />
            {site.serviceArea}
          </motion.p>
        </div>
      </div>
    </section>;
}